// src/ResetPasswordSuccessScreen.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export default function ResetPasswordSuccessScreen() {
  const navigate = useNavigate();

  return (
    <div style={styles.wrapper}>
      {/* Cabeçalho com logo */}
      <div style={styles.header}>
        <img
          src={process.env.PUBLIC_URL + '/ic_target.png'}
          alt="SPX Logo"
          style={styles.logo}
        />
      </div>

      {/* Conteúdo principal */}
      <div style={styles.container}>
        <h2 style={styles.title}>Redefinir Senha</h2>

        <div style={styles.successBox}>
          <CheckCircle color="green" size={40} />
          <p style={styles.successText}>Sua senha foi redefinida com sucesso!</p>
        </div>

        <button
          style={styles.button}
          onClick={() => navigate('/')}
        >
          Entrar
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: '100vh',
    backgroundColor: '#fff',
  },
  header: {
    width: '100%',
    backgroundColor: '#EE4D2D',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 16,
    paddingBottom: 12,
  },
  logo: {
    height: 64,
    objectFit: 'contain',
  },
  container: {
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 48, // 🔼 aumentei o espaçamento entre o título e o box
  },
  successBox: {
    width: '100%',
    backgroundColor: '#E8F5E9',
    border: '1px solid #81C784',
    borderRadius: 8,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 48, // 🔼 aumentei o espaçamento entre o box e o botão
  },
  successText: {
    fontSize: 16,
    color: '#2E7D32',
    textAlign: 'center',
    marginTop: 8,
  },
  button: {
    backgroundColor: '#EE4D2D',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    padding: '12px 16px',
    fontSize: 16,
    fontWeight: 'bold',
    cursor: 'pointer',
    width: '100%',
    maxWidth: 350,
  },
};
